import { Divider, Modal, ModalBody, ModalContent, ModalHeader } from '@nextui-org/react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { IconClose } from '@/assets';
import { Buttons, Images } from '@/components';
import RenderWhen from '@/components/RenderWhen';
import { useAuth } from '@/provider/UserProvider';
import { getPromptById } from '@/services/prompt';
import type { Prompt } from '@/types/prompt';
import { currencyFormatter } from '@/utils/currency';
import { withServerTryCatch } from '@/utils/serviceHelper';

const BuyPrompt: React.FC<{
  id: number | string;
  onOpenChange: () => void;
  isOpen: boolean;
  onOpenCheckout: () => void;
}> = ({ id, isOpen, onOpenChange, onOpenCheckout }) => {
  const { isLogin } = useAuth();
  const [isReady, setIsReady] = useState(false);
  const handleContinue = (onClose: () => void) => {
    if (!isLogin) {
      toast.error('Please connect wallet to continue.');
      return;
    }
    onClose();
    onOpenCheckout();
  };

  const [promptDetail, setpromptDetail] = useState<Prompt>();
  const getDataDetail = async (id: number | string) => {
    const resPrompt = await withServerTryCatch(async () => getPromptById(id), { data: {} });
    setpromptDetail(resPrompt.data);
    setIsReady(true);
  };
  useEffect(() => {
    getDataDetail(id);
  }, [id]);
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
      scrollBehavior="inside"
      placement="center"
    >
      <ModalContent className="min-w-[500px] rounded-[20px] sm:min-w-0">
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center justify-between p-8 pb-0 sm:p-5">
              <span className="text-[24px] font-[600] sm:text-[18px]">Buy prompt</span>
              <div
                onClick={() => {
                  onClose();
                }}
                className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[8px] bg-gray-100"
              >
                <IconClose />
              </div>
            </ModalHeader>
            <ModalBody className="gap-0 px-[32px] py-0 sm:px-5">
              <div className="mt-7 flex items-center">
                <div className="h-[80px] w-[80px] overflow-hidden rounded-[4px] sm:h-[60px] sm:w-[60px]">
                  <Images className="object-cover" src={promptDetail?.avatar} alt="thumbnail" />
                </div>
                <div className="w-[calc(100%-200px)] pl-5 sm:w-[calc(100%-140px)] sm:pl-2">
                  <p className="line-clamp-2 text-[20px] font-semibold text-black sm:text-[16px]">
                    {promptDetail?.name}
                  </p>
                  <span className="line-clamp-1 text-[16px] text-gray-500 sm:text-[13px]">
                    {promptDetail?.creatorProvider?.username || 'Unname'}
                  </span>
                </div>
                <div className="w-[120px] text-right sm:w-[80px]">
                  <p className="text-[20px] font-semibold text-black sm:text-[16px]">
                    ${currencyFormatter(promptDetail?.asset?.offer?.amount || 0)}
                  </p>
                </div>
              </div>
              <Divider className="my-10 bg-gray-100 sm:my-6" />
              <div className="flex justify-between">
                <p className="text-[20px] font-semibold text-black sm:text-[16px]">Total price</p>
                <p className="text-[20px] font-semibold text-black sm:text-[16px]">
                  ${currencyFormatter(promptDetail?.asset?.offer?.amount || 0)}
                </p>
              </div>
              <Divider className="my-10 bg-gray-100 sm:my-6" />
              <RenderWhen.If isTrue={isReady}>
                <Buttons onClick={() => handleContinue(onClose)} className="mb-10 sm:mb-6">
                  Continue to payment
                </Buttons>
              </RenderWhen.If>
              <RenderWhen.If isTrue={!isReady}>
                <Buttons typeBtn="disabled" disabled className="mb-10 sm:mb-6">
                  Loading...
                </Buttons>
              </RenderWhen.If>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default BuyPrompt;
